import React from "react";
import "../styles/OrderHistory.css";

const PreregistrosOverview = ({
  items = [],
  loading,
  error,
  onRefresh,
  onApprove,
  onDelete,
  busyEmail,
}) => {
  return (
    <section className="order-history admin-users-overview">
      <header className="history-header">
        <div>
          <h3 className="history-title">Preinscritos</h3>
          <p className="history-subtitle">Solicitudes pendientes desde el login público.</p>
        </div>
        <div className="history-toolbar">
          <button type="button" className="history-refresh-btn" onClick={onRefresh} disabled={loading}>
            {loading ? "Actualizando..." : "Actualizar"}
          </button>
        </div>
      </header>

      {error ? <div className="history-error">{error}</div> : null}

      {loading && items.length === 0 ? (
        <div className="history-loading"><div className="history-spinner" />Cargando preinscritos...</div>
      ) : items.length === 0 ? (
        <div className="history-empty">Sin preregistros pendientes.</div>
      ) : (
        <div className="history-table-wrap">
          <table className="history-table">
            <thead>
              <tr>
                <th>Correo</th>
                <th>Nombre</th>
                <th>Móvil</th>
                <th>Fecha</th>
                <th className="align-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => {
                const busy = busyEmail === item?.username;
                return (
                  <tr key={`${item?.username}-${idx}`} className="history-row flat">
                    <td className="history-symbol-cell">{item?.username}</td>
                    <td>{item?.full_name || "—"}</td>
                    <td>{item?.mobile_phone || "—"}</td>
                    <td className="mono">{String(item?.created_at || "").slice(0, 16).replace("T", " ") || "—"}</td>
                    <td className="align-center">
                      <div className="history-action-group">
                        <button type="button" className="history-action-btn tone-positive" onClick={() => onApprove?.(item)} disabled={busy}>
                          Aprobar
                        </button>
                        <button type="button" className="history-action-btn tone-negative" onClick={() => onDelete?.(item?.username)} disabled={busy}>
                          {busy ? "Procesando..." : "Eliminar"}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default React.memo(PreregistrosOverview);
